import React from 'react';

const Chess = () => {
  const url = "http://134.122.96.92:8000/wav"


  return (
    <div className="main">
      <button
        onClick={() =>  audioPlay(url)}
    >Getting sound from server</button>
    </div>
  )
}


const audioPlay = async url => {
  const context = new AudioContext();
  const source = context.createBufferSource();
  const audioBuffer = await fetch(url)
    .then(res => res.arrayBuffer())
    .then(ArrayBuffer => context.decodeAudioData(ArrayBuffer));

  source.buffer = audioBuffer;
  source.connect(context.destination);
  source.start();
};


export { Chess }


